<template>
  <div class="main-content">
    <div class="page-content">
      <!-- start page title -->
      <app-page-title title="Squads" :breadcrumbs="breadcrumbs" />
      <!-- end page title -->
      <template v-if="items && list">
        <group-list :items="items" @handle="handleSquad" @handle2="handleExclude" />
      </template>
      <template v-else>
        <group-form :users="users" :item="item" @handle="handleUpdate" @handle2="alterLayout" />
      </template>
    </div>
    <!-- End Page-content -->
  </div>
</template>
<script>
import AppPageTitle from "@/components/AppPageTitle/AppPageTitle.vue";
import GroupList from "@/views/admin/groups/List.vue";
import GroupForm from "@/views/admin/groups/Form.vue";
import { mapActions } from "vuex";
export default {
  components: {
    AppPageTitle,
    GroupForm,
    GroupList
  },
  data() {
    return {
      total: 0,
      items: null,
      item: null,
      list: true,
      users: null,
      breadcrumbs: [],
      breadcrumbsDefault: ["Configurações", "Squads"]
    };
  },
  mounted() {
    this.breadcrumbs = this.breadcrumbsDefault;
    this.getGroups();
    this.getUsers();
  },
  methods: {
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    alterLayout() {
      this.list = !this.list;
      this.breadcrumbs =
        this.list === true
          ? this.breadcrumbsDefault
          : ["Configurações", "Squad"];
    },
    getUsers() {
      const options = this.$getAPIHeaders("GET", "user");
      let _this = this;
      this.axios(options)
        .then(function(response) {
          _this.users = response.data.data.data.user;
        })
        .catch(function(error) {
          
          _this.showMessage({
            title: error.response.data.message,
            text: _this.$root.$options.filters.objectError(
              error.response.data.errors
            ),
            css: "bg-danger"
          });
        });
    },
    getGroups() {
      const options = this.$getAPIHeaders("GET", "team");
      this.showLoader(true);
      let _this = this;
      this.axios(options)
        .then(function(response) {
          _this.items = response.data.data.data;
          _this.showLoader(false);
        })
        .catch(function(error) {
          _this.showLoader(false);
          
          _this.showMessage({
            title: error.response.data.message,
            text: _this.$root.$options.filters.objectError(
              error.response.data.errors
            ),
            css: "bg-danger"
          });
        });
    },
    handleUpdate(newObj = null) {
      
      if (Object.keys(newObj).length > 0) {
        
        this.updateObject(newObj);
      }
      this.alterLayout();
    },
    updateObject(newObj) {
      
      const index = this.items.findIndex(item => item.id === newObj.id);
      if (index !== -1) {
        
        this.items[index] = {
          ...this.items[index],
          ...newObj
        };
      } else {
        
        this.items.push(newObj);
      }
      
    },
    handleSquad(id) {
      
      if (id) {
        this.item = this.items.find(el => el.id === id);
      } else {
        this.item = null;
      }
      
      this.alterLayout();
    },
    handleExclude(id){
      let temp = this.items.filter(el => el.id != id);
      this.items = temp;
    }
  }
};
</script>